import { Component, Vue } from "vue-property-decorator";

import * as Constant from "@/constant";
import { Log } from "@/util";

@Component
export default class Common extends Vue {
  public constant = Constant;

  public mixinsExample() {
    Log.info("hello mixins");
  }
}
